<script lang="ts">
  import { getDeviceConfig } from '$lib/devices/registry';
  import type { DeviceType } from '$lib/constants';
  import type { Component } from 'svelte';
  import { Loader } from '@lucide/svelte';

  interface Props {
    deviceType: DeviceType;
    isConnecting?: boolean;
  }

  let { deviceType, isConnecting = false }: Props = $props();

  let IconComponent: Component | null = $state(null);
  let loading = $state(false);

  $effect(() => {
    const loadComponent = async () => {
      const config = getDeviceConfig(deviceType);
      loading = true;

      try {
        const module = await config.icon();
        IconComponent = module.default;
      } catch (error) {
        console.error('Failed to load device icon:', error);
        IconComponent = null;
      } finally {
        loading = false;
      }
    };
    loadComponent();
  });
</script>

{#if loading}
  <div class="h-10 w-10 animate-pulse rounded bg-slate-300"></div>
{:else if isConnecting}
  <Loader class="animate-spin" />
{:else if IconComponent}
  <IconComponent />
{/if}
